import { extractPersonFromJsonLd } from './extractPerson';
export var extractMembers = function extractMembers(jsonLd) {
  var members = jsonLd['atlassian:member'];
  if (members) {
    if (typeof members === 'string') {
      throw Error('Link[atlassian:members] must be an array or object.');
    } else if (members.hasOwnProperty('totalItems')) {
      var collection = members;
      if (collection.items) {
        return collection.items.map(function (member) {
          return extractPersonFromJsonLd(member);
        }).filter(function (member) {
          return !!member;
        });
      }
    } else {
      var memberItem = members;
      var memberItemForLink = extractPersonFromJsonLd(memberItem);
      if (memberItemForLink) {
        return [memberItemForLink];
      }
    }
  }
};